module.exports = __webpack_public_path__ + "static/img/wish.18bf4d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wish.png
// module id = VpHP
// module chunks = 1